import type { IAffiliateTrackerPayload } from '@modules/affiliate-trackers/types';
import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_TRACKERS_LIST_QUERY_KEY,
  AFFILIATE_TRACKERS_PERMISSIONS,
  AFFILIATE_TRACKERS_SAVE_MUTATION_KEY,
  AFFILIATE_TRACKERS_SAVE_URL,
} from '../constants';

export default function useAffiliateTrackersCreateEditMutation(): IContextMutationResult<void, Error, IAffiliateTrackerPayload> {
  const { fetchPost, fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IAffiliateTrackerPayload>({
    mutationKey: [AFFILIATE_TRACKERS_SAVE_MUTATION_KEY],
    mutationFn: (tracker) => (
      tracker.id
        ? fetchPut<void>(
            AFFILIATE_TRACKERS_SAVE_URL,
            { tracker },
            {
              permission: AFFILIATE_TRACKERS_PERMISSIONS.EDIT,
              urlParams: {
                id: tracker.id,
              },
            },
          )
        : fetchPost<void>(
            AFFILIATE_TRACKERS_SAVE_URL,
            { tracker },
            {
              permission: AFFILIATE_TRACKERS_PERMISSIONS.CREATE,
              urlParams: {
                id: '',
              },
            },
          )
    ),
    onSuccess({ queryClient, variables }) {
      displayPresetToast(variables.id ? 'edited' : 'created');
      void queryClient.invalidateQueries({ queryKey: [AFFILIATE_TRACKERS_LIST_QUERY_KEY] });
    },
  });
}
